// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__bpngu","content":"styles_content__3MBwF","checkbox":"styles_checkbox__2pB0_","checkboxLabel":"styles_checkboxLabel__6KyyT"};